import { lazy } from "react";
import type { WidgetDefinition } from "@pulse-ui/widget-sdk";

export const CLOUD_WIDGETS: Record<string, WidgetDefinition> = {
  "role-management-widget": {
    id: "role-management-widget",
    name: "Role Management",
    description: "Manage organization users, roles, and portfolio access",
    category: "Management",
    component: lazy(() => import("@pulse-ui/role-management-widget")),
    adminOnly: true,
    isLinkable: false,
  },
};

export function getCloudWidgetRegistry(
  isAdmin: boolean,
  userRoles: string[] = []
): Record<string, WidgetDefinition> {
  const effectiveRoles = isAdmin ? [...userRoles, "admin"] : userRoles;
  return Object.fromEntries(
    Object.entries(CLOUD_WIDGETS).filter(([, def]) => {
      if (def.requiredRoles) {
        return def.requiredRoles.some((r) => effectiveRoles.includes(r));
      }
      if (def.adminOnly) return isAdmin;
      return true;
    })
  );
}
